import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { createBaseSelector, registerSlice } from '@shared/lib/redux'

import { Toast, ToastWithoutId } from '../types'
import { generateId } from './redux-toast.lib'

export type ToastsStore = {
  toasts: Toast[]
}

const initialState: ToastsStore = {
  toasts: []
}

export const toastsSlice = createSlice({
  name: 'toasts',
  initialState,
  reducers: {
    addToast: {
      reducer: (state, action: PayloadAction<Toast>) => {
        state.toasts.push(action.payload)
      },
      // Подготовительный action creator
      prepare: (toast: ToastWithoutId) => ({
        payload: {
          id: generateId(),
          ...toast
        }
      })
    },
    removeToast: (state, action: PayloadAction<string>) => {
      state.toasts = state.toasts.filter((toast) => toast.id !== action.payload)
    }
  }
})

const collectionListBaseSelector = createBaseSelector(toastsSlice)
registerSlice([toastsSlice])

const selectToastList = createSelector(collectionListBaseSelector, (s) => {
  return {
    items: s.toasts
  }
})

export const toastListStore = {
  actions: { ...toastsSlice.actions },
  selectors: {
    selectToastList
  },
  name: toastsSlice.name
}
